import * as React from "react"
// import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import Box from "@mui/material/Box"
import SwipeableDrawer from "@mui/material/SwipeableDrawer"
import IconButton from '@mui/material/IconButton';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FooterMenu } from '../../features/footer';
import {
  RiSettings5Fill,
  // RiGobletFill,
  RiUser3Fill,
  // RiLuggageCartLine,
  RiStarFill,
  RiHome2Line
} from "react-icons/ri";
// import { SiWelcometothejungle } from "react-icons/si";
import { 
  // GiBarrel,
  // GiPriceTag
} from "react-icons/gi";
// import { 
//   MdSecurityUpdateGood,
// } from "react-icons/md";
// import { 
//   HiSpeakerphone
// } from "react-icons/hi";
import { 
  TbReportSearch
} from "react-icons/tb";
import { 
  GrDocumentVerified,
  GrDocumentPerformance,
  // GrLogout
} from "react-icons/gr";
// import {
//   BiBookOpen
// } from "react-icons/bi";
import {
  SubMenu,
  Menu,
  MenuItem
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

function Sidedrawer() {

  const { user } = useAuthenticator((context) => [context.user]);
  // Get user type
  const userType = user.attributes["custom:user_type"];
  console.log(userType)

  // const { route, signOut } = useAuthenticator((context) => [
  //   context.route,
  //   context.signOut,
  // ]);
  // const navigate = useNavigate();

  // function logOut() {
  //   signOut();
  //   navigate('/');
  // }
  
  const [state, setState] = React.useState({
    left: false
  })

  const toggleDrawer = (anchor, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }


  const listdistri = anchor => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 310 }}
      role="presentation"
      // onClick={toggleDrawer(anchor, true)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Menu>
        <MenuItem />
        <MenuItem />
        <MenuItem 
          component={<Link to="/home" />}
          icon={<RiHome2Line />}
        >
        Home
        </MenuItem>
        
        
        <SubMenu defaultclosed="true" label={"Settings"} icon={<RiSettings5Fill />}>
          <MenuItem 
            icon={<RiUser3Fill />}
            component={<Link to="/profile" />}
          >
          Profile
          </MenuItem>
        
        </SubMenu>
          {/* {route !== "authenticated" ? (
            <br></br>
          ) : (
            <MenuItem icon={<GrLogout />} onClick={() => logOut()}>Esci</MenuItem>
          )} */}
        <FooterMenu/>
      </Menu>
    </Box>
  )







  const list = anchor => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 310 }}
      role="presentation"
      // onClick={toggleDrawer(anchor, true)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Menu>
        <MenuItem />
        <MenuItem />
        <MenuItem 
          component={<Link to="/home" />}
          icon={<RiHome2Line />}
        >
        Home
        </MenuItem>
        {/* <SubMenu defaultclosed="true" label={"Catalogo"} icon={<GiBarrel />}>
          <MenuItem 
            component={<Link to="/addproduct" />}
          >
          Aggiungi un prodotto
          </MenuItem>
        </SubMenu> */}
        {/* <SubMenu defaultclosed="true" label={"Ordini"} icon={<RiLuggageCartLine />}>
          <MenuItem>Ordini aperti</MenuItem>
          <MenuItem>Ordini eseguiti</MenuItem>
        </SubMenu>
        <SubMenu defaultclosed="true" label={"Campioni"} icon={<RiGobletFill />}>
          <MenuItem>Richieste aperte</MenuItem>
          <MenuItem>Richieste passate</MenuItem>
        </SubMenu> */}
        {/* <MenuItem 
          component={<Link to="/welcome" />}
          icon={<SiWelcometothejungle />}
        >
        Welcome
        </MenuItem> */}
        <MenuItem disabled icon={<GrDocumentPerformance />}>Rendimento</MenuItem>
        <MenuItem disabled icon={<TbReportSearch />}>Reportistica</MenuItem>
        {/* <MenuItem icon={<MdOutlineInventory2 />}>Inventario</MenuItem>
        <MenuItem icon={<HiSpeakerphone />}>Prezzistica</MenuItem> */}
        <SubMenu defaultclosed="true" label={"Impostazioni"} icon={<RiSettings5Fill />}>
          <MenuItem 
            icon={<RiUser3Fill />}
            component={<Link to="/profile" />}
          >
          Profilo
          </MenuItem>
          <MenuItem 
            disabled
            icon={<RiStarFill />}
          >
          Membership
          </MenuItem>
          {/* <MenuItem 
            disabled
            icon={<MdSecurityUpdateGood />}
            component={<Link to="/security" />}
          >
          Sicurezza
          </MenuItem> */}
          <MenuItem 
            disabled
            icon={<GrDocumentVerified />}
            component={<Link to="/verification" />}
          >
          Processo di verifica
          </MenuItem>
          <MenuItem 
            disabled
            icon={<GrDocumentVerified />}
            component={<Link to="/brand-registration" />}
          >
          Registrazione del marchio
          </MenuItem>
          {/* <MenuItem 
            icon={<BiBookOpen />}
            component={<Link to="/instructions" />}
          >
          Istruzioni
          </MenuItem> */}
        </SubMenu>
          {/* {route !== "authenticated" ? (
            <br></br>
          ) : (
            <MenuItem icon={<GrLogout />} onClick={() => logOut()}>Esci</MenuItem>
          )} */}
        <FooterMenu/>
      </Menu>
    </Box>
  )

  return (
    <>
      {userType === "producer"? (
        
        <>
        <div>
          <React.Fragment key="left">
          <IconButton onClick={toggleDrawer("left", true)}>
            <FontAwesomeIcon icon={faBars} style={{ color: 'white' }} />
          </IconButton>
          <SwipeableDrawer
            anchor="left"
            open={state["left"]}
            onClose={toggleDrawer("left", false)}
            onOpen={toggleDrawer("left", true)}
          >
            {list("left")}
          </SwipeableDrawer>
          </React.Fragment>
        </div>
        </>
      ) : (
       
        <>
        <div>
          <React.Fragment key="left">
          <IconButton onClick={toggleDrawer("left", true)}>
            <FontAwesomeIcon icon={faBars} style={{ color: 'white' }} />
          </IconButton>
          <SwipeableDrawer
            anchor="left"
            open={state["left"]}
            onClose={toggleDrawer("left", false)}
            onOpen={toggleDrawer("left", true)}
          >
            {listdistri("left")}
          </SwipeableDrawer>
          </React.Fragment>
        </div>
        </>
      )}
    
    
      </>
      
  );
}
export default Sidedrawer;
